import styled from '@emotion/styled'
import {PALETTE} from '../styles/paletteV3'

const StyledError = styled('div')({
  color: PALETTE.TOMATO_500,
  fontWeight: 600,
  textAlign: 'center'
})

export default StyledError
